import React from "react";
import { Link } from "react-router-dom";
import { XCircle, ArrowLeft } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen flex items-center justify-center px-5 pt-28">
      <div className="max-w-lg w-full text-center" data-testid="payment-cancel-page">
        <XCircle size={64} className="text-zinc-500 mx-auto mb-6" />
        <span className="font-mono-tech text-xs tracking-[0.3em] uppercase text-zinc-500">
          / Checkout cancelled
        </span>
        <h1 className="font-display font-black text-5xl tracking-tighter mt-3 leading-none">
          NO WORRIES.
        </h1>
        <p className="text-zinc-400 mt-5 leading-relaxed">
          Your cart is still saved. Whenever you're ready, pick up right where you left off — no
          charge has been made.
        </p>
        <Link
          to="/shop"
          className="inline-flex items-center gap-2 bg-accent hover:bg-accent-hover text-white font-display font-bold uppercase tracking-wide px-7 py-4 mt-8 transition-colors clip-corner"
        >
          <ArrowLeft size={18} /> Back to Shop
        </Link>
      </div>
    </div>
  );
}
